import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { tiposMovimientoPersonaAPI } from '../services/api';
import { toast } from 'react-toastify';
import '../Clientes.css';

const TipoMovimientoPersonaForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    activo: true
  });

  const loadTipo = useCallback(async () => {
    try {
      const response = await tiposMovimientoPersonaAPI.getById(id);
      if (response.success) {
        setFormData({
          nombre: response.data.nombre || '',
          descripcion: response.data.descripcion || '',
          activo: response.data.activo !== false
        });
      }
    } catch (error) {
      toast.error('Error al cargar tipo');
      navigate('/tipos-movimiento-persona');
    }
  }, [id, navigate]);

  useEffect(() => {
    if (id) loadTipo();
  }, [id, loadTipo]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let response;
      if (id) {
        response = await tiposMovimientoPersonaAPI.update(id, formData);
      } else {
        response = await tiposMovimientoPersonaAPI.create(formData);
      }
      if (response.success) {
        toast.success(id ? 'Tipo actualizado' : 'Tipo creado');
        navigate('/tipos-movimiento-persona');
      }
    } catch (error) {
      toast.error(error.message || 'Error al guardar tipo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cliente-form">
      <h1>{id ? 'Editar tipo de movimiento de persona' : 'Nuevo tipo de movimiento de persona'}</h1>

      <form onSubmit={handleSubmit} className="form-container">
        <div className="form-row">
          <div className="form-group">
            <label>Nombre *</label>
            <input
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
              placeholder="Ej: Ingreso, Egreso, Préstamo..."
            />
          </div>
        </div>

        <div className="form-group">
          <label>Descripción</label>
          <textarea
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            rows="3"
            placeholder="Descripción opcional del tipo"
            style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '16px', width: '100%' }}
          />
        </div>

        <div className="form-group">
          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input type="checkbox" name="activo" checked={formData.activo} onChange={handleChange} />
            Activo
          </label>
        </div>

        <div className="form-actions">
          <button type="button" onClick={() => navigate('/tipos-movimiento-persona')} className="btn-secondary">
            Cancelar
          </button>
          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TipoMovimientoPersonaForm;
